<template>
  <div class="result-group">
    <div class="result-title-wrap">
      <h3 ref="SeeMoreTopRef">{{ title }}</h3>
      <p><span>{{ totalElements }}</span>건</p>
    </div>

    <ul v-if="results && results.length > 0" class="favorite artwork">
      <transition-group name="fade">
        <li v-for="(artWork, index) in results" :key="artWork.uuid">
          <img :src="artWork.imageUrl" :alt="artWork.title || artWork.titleEn" class="artWorkImg" loading="lazy">
          <div class="mask">
            <!--            <p>{{ artWork.title || artWork.titleEn}}<br/>{{ artWork.year }}</p>-->
            <p
                v-for="(line, idx) in Object.values(artWork.highlight).flat()"
                :key="idx"
                v-html="line"
            />
          </div>
          <button type="button" class="btn-more" @click.stop.prevent="artWorkModalOpen(index)">See More</button>
        </li>
      </transition-group>

    </ul>

    <SeeMoreButton
        :totalPages="totalPages"
        :currentPage="currentPage"
        :fetchItems="fetchSearchData"
        :itemRef="SeeMoreTopRef"
    />
  </div>

  <ArtWorksModalSwiper
      v-model:isArtWorkModalOpen="isModalOpen"
      v-model:artWorks="results"
      :slideIndex="artWorksSlideIndex"
      location="favoriteArtwork"
      :totalPages="totalPages"
      :currentPage="currentPage"
      :fetchItems="fetchSearchData"
  />


</template>

<script setup>
import {defineProps, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {apiClient} from "@/services/auth-header";
import {useUiStore} from "@/store/useUiStore";
import SeeMoreButton from "@/components/ui/SeeMoreButton.vue";
import ArtWorksModalSwiper from "@/components/ui/ArtWorksModalSwiper.vue";

const uiStore = useUiStore();

const props = defineProps({
  query: {type: String, required: true},
  title: {type: String, required: true},
  indexName: {type: String, required: true},
  routerName: {type: String, required: false},
});

watch(
    () => props.query,
    (newQuery) => {
      fetchSearchData();
    }
)

const emit = defineEmits(['update:totalElements'])

const results = ref(null);
const index = ref(props.indexName)
const currentPage = ref(0);
const totalPages = ref(0);
const isFetching = ref(false);
const SeeMoreTopRef = ref(null);
const totalElements = ref(0);
const size = ref(getSizeByWindowWidth());

function getSizeByWindowWidth() {
  const width = window.innerWidth;

  if (width >= 1280) return 10;
  if (width >= 1024) return 8;
  //if (width >= 600) return 6;
  return 6;
}

const fetchSearchData = async (page = 0, append = false) => {
  if (isFetching.value) {
    return;
  }
  isFetching.value = true;

  try {
    const response = await apiClient.get(`/v1/search/unified-field/${index.value}?q=${props.query}&page=${page}&size=${size.value}`);
    const newData = response.data.content;
    // console.log(index.value, " response.data ", response.data)
    if (append) {
      results.value.push(...newData);
    } else {
      results.value = newData;
    }
    totalElements.value = response.data.totalElements;
    currentPage.value = response.data.pageable.pageNumber;
    totalPages.value = response.data.totalPages;
    emit('update:totalElements', { key: 'ART & ARTIST', value: totalElements.value });
  } catch (error) {
    console.error("Error fetching result data:", error);
  } finally {
    isFetching.value = false;
  }
};

const isModalOpen = ref(false);
const artWorksSlideIndex = ref(-1);
const artWorkModalOpen = (index) => {
  artWorksSlideIndex.value = index
  isModalOpen.value = true;
}

watch(() => isModalOpen.value, (newVal) => {
  if (newVal) {
    uiStore.showOverlay();
  } else {
    uiStore.hideOverlay();
  }
})

onMounted(async () => {
  //await fetchSearchData(currentPage.value);
});

</script>

<style scoped>
.result-group ul.favorite li {
  aspect-ratio: 1 / 1;
  object-fit: cover;
}

.result-group ul.favorite li img.artWorkImg {
  border-radius: 20px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.result-group ul.favorite li .mask em {
  color: #FFD353 !important;
}

.result-group ul.favorite.artwork li {
  width: calc((100% - 168px) / 5);
}

@media (max-width: 1280px) {
  .result-group ul.favorite.artwork li {
    width: calc((100% - 126px) / 4);
  }
}

@media (max-width: 1024px) {
  .result-group ul.favorite.artwork li {
    width: calc((100% - 72px) / 3);
  }
}

@media (max-width: 600px) {
  .result-group ul.favorite.artwork li {
    width: calc((100% - 12px) / 2);
  }
}

</style>